<template>
  <div class="mb-12 pa-2" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'"> 
    <div class="d-flex">
      <v-text-field
        filled
        rounded
        dense 
        :hide-details="true"
        placeholder="Cari penjualan . . ."
        v-model="filter.code"
        clearable
        color="#ff618a"
        @click:clear="filter.code = ''; fetch()"
        v-on:keyup.enter="fetch()"
        prepend-inner-icon="mdi-magnify">
      </v-text-field>
    </div>

    <div class="my-5">
      <div class="title text--secondary">
        Data Penjualan
      </div>
      <div class="caption text--secondary">
        {{ pagination.totalData }} Penjualan Ditemukan
      </div>
      <div>
        <v-row>
          <v-col cols="12" md="3">
            <v-expansion-panels 
              multiple
              flat
              v-model="panel">
              <v-expansion-panel
                style="position: initial; background: transparent;"
                class="mt-0">
                <v-expansion-panel-header class="font-weight-bold">
                  <div class="d-flex align-baseline">
                    <v-icon small>mdi-filter</v-icon>
                    <div class="ml-1 body-2 text--secondary">
                      Filter
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-radio-group v-model="sort.selected" :mandatory="false" class="mt-0">
                    <v-radio 
                      color="#ff618a"
                      v-for="(submenu, index) in sort.submenu"
                      :key="index" 
                      :label="submenu.text" 
                      :value="submenu.value"
                      v-on:change="toSort(submenu.value)"
                      class="py-1">
                    </v-radio>
                  </v-radio-group>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          
          <v-col cols="12" md="9">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.run"
              transition="scale-transition"
              type="list-item-two-line"
              v-for="(l, index) in process.run ? 10:list"
              :key="index">
              <v-list dense class="line my-3 mr-5" 
                :class="{
                  'mt-0' : index === 0
                }">
                <v-list-item v-if="!process.run && list.length > 0"
                  :to="`/transaction/selling/${l.id}`">
                  <v-list-item-content  
                    class="cursor-pointer">
                    <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                      {{ l.invoiceCode }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-regular" v-if="$vuetify.breakpoint.name !== 'xs'">
                      <span v-if="l.invoiceStatus === 'ok'" class="font-weight-bold green--text">
                        Ok
                      </span>
                      <span v-if="l.invoiceStatus === 'pending'" class="font-weight-bold">
                        Pending
                      </span>
                      <span v-if="l.invoiceStatus === 'confirmed'" class="font-weight-bold pink--text">
                        Menunggu Konfirmasi
                      </span>
                      <span v-if="l.invoiceStatus === 'failed'" class="font-weight-bold red--text">
                        Pembelian Gagal
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content 
                    class="cursor-pointer" 
                    v-if="$vuetify.breakpoint.name !== 'xs'">
                    <v-list-item-title class="body-2 grey--text text--darken-2">
                      <v-icon>mdi-account</v-icon> {{ l.invoiceUserName }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin" v-if="$vuetify.breakpoint.name !== 'xs'">
                      Nama Pembeli
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content  
                    class="cursor-pointer"
                    v-if="$vuetify.breakpoint.name !== 'xs'">
                    <v-list-item-title class="body-2 grey--text text--darken-2">
                      {{ l.invoiceDate | date }}
                      <v-list-item-subtitle class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin">
                        Batas Pembayaran {{ l.invoiceDueDate | date }}
                      </v-list-item-subtitle>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content  
                    class="cursor-pointer"
                    v-if="$vuetify.breakpoint.name !== 'xs'">
                    <v-list-item-title class="body-2 grey--text text--darken-2">
                      {{ l.invoiceTotalPrice | price }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin" v-if="$vuetify.breakpoint.name !== 'xs'">
                      Total Harga
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-skeleton-loader>
            <Empty v-show="!process.run && list.length < 1" content="Data Penjualan"/>
            <div v-if="pagination.totalPage > 1">
              <v-row>
                <v-col cols="5">
                  <div class="body-2	font-weight-bold mt-4">
                    Total {{ pagination.totalData }} data
                  </div>
                </v-col>
                <v-col cols="7">
                  <div class="float-right">
                    <v-pagination
                      v-model="page"
                      :length="pagination.totalPage"
                      :total-visible="5"
                      color="#ff618a"
                      @input="fetch(page)"
                      circle>
                    </v-pagination>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  import Empty from "../../../../components/DataEmpty"; 
  export default {
    data () {
      return {
        panel: [0],
        filter: {
          code: ''
        },
        list: [],
        pagination: {},
        page: 1,
        sort: {
          selected: 'all',
          submenu: [
            {
              value: 'all',
              text: 'Semua',
            },
            {
              value: 'ok',
              text: 'Ok',
            },
            {
              value: 'pending',
              text: 'Pending',
            },
            {
              value: 'confirmed',
              text: 'Menunggu Konfirmasi',
            },
            {
              value: 'failed',
              text: 'Gagal',
            }
          ]
        },
        process: {
          run: false
        },
        response: ''
      }
    },
    components: {
      Empty 
    },
    mounted () {
      window.scrollTo(0, 0)
      this.fetch()
    },   
    methods: { 
      async fetch(p) {
        if (p === undefined) {
          this.page = 1
        }
        this.process.run = true
        await get(`api/internal/invoice`, {
          params: {
            pagenum: p,
            code: this.filter.code,
            status: this.sort.selected === 'all' ? '' : this.sort.selected
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.list = res.data
            this.pagination = res.pagination
          }
        })
      },
      toSort(value) {
        this.sort.selected = value
        this.fetch()
      }
    }
  }
</script>

